<template>
	<b-modal
		id="cancel-reservation-modal"
		size="sm"
		body-class="position-static"
		hide-header
		centered
		v-model="showModal"
		>
		La reserva sera <strong>cancelada</strong> y no sera posible reactivarla
		<hr>
		<b-form-group label="Registra una nota">
			<b-textarea v-model="note" />
		</b-form-group>

		<template #modal-footer="{ close }">
			<b-button :disabled="loading" @click="close()" type="button" class="float-right">
				Cerrar
			</b-button>
			<b-button :disabled="loading" @click="doCancel" type="button" variant="danger" class="float-right">
				<span v-if="!loading">Cancelar Reserva</span>
				<span v-else><b-spinner small></b-spinner> Procesando...</span>
			</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	props: {
		reservationId : {
			type: Number,
			required: true,
		},
		show : {
			type: Boolean,
			required: true,
		}
	},
	components: {

	},
	data(){
		return {
			loading : false,
			note : '',
		}
	},
	methods : {
		doCancel(){
			this.loading = true
			this.$root.api.post(`/reservations/${this.reservationId}/cancel`,{ note : this.note }).then( () => {
				this.$root.showAlert('Reserva cancelada con éxito')
				this.loading = false
				this.note = ''
				this.showModal = false
				this.$emit('onCancel')
			}).catch(this.$root.handleRequestError);
		},
	},
	computed : {
		showModal : {
			get(){
				return this.show
			},
			set(val){
				this.$emit('update:show',val)
			}
		}
	}
}
</script>
